import { KbVector } from '@kb3d/models/classes/primitives/kb-vector';
import { Kb3dModel } from '../decorators/kb3d-decorator';
import { instanceOf } from '../decorators/model-utils';
import { ICircularPatternFeature } from '../kb3d-models';
import { Kb3dObject } from '../kb3d-object';
import { Token } from '../token';
import { ALL_GEOMETRY } from './feature';
import { PatternFeature } from './pattern-feature';

@Kb3dModel({
    token: Token.CircularPatternFeature,
})
export class CircularPatternFeature extends PatternFeature implements ICircularPatternFeature {
    static _affects = new Set(ALL_GEOMETRY);
    static _affectedBy = new Set(ALL_GEOMETRY);

    arc: number;
    pivot: KbVector;
    axis: KbVector;
}

export function isCircularPattern(o: Kb3dObject): o is CircularPatternFeature {
    return instanceOf(o, Token.CircularPatternFeature);
}
